import { Button, InputBase, styled } from '@mui/material';

export const TopBarW = styled('div')<{ isMobile?: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: ${({ isMobile }) => (isMobile ? '80px' : '96px')};
  display: flex;
  align-items: center;
  border-bottom: 3px solid #8282fa;

  padding: 0 88px 0 88px;
  background: ${({ theme }) => theme.palette.white.light};
  backdrop-filter: blur(20px);
  z-index: 1000;
  gap: 16px;
  box-shadow: ${({ theme }) => `0 1px 0 ${theme.palette.primary.p010}`};

  @media (max-width: 1023px) {
    padding: 0 12px;
    gap: 8px;
  }
`;

export const LogoW = styled('div')`
  display: flex;
  align-items: center;
  width: 136px;
  height: 45px;
  gap: 10px;
  flex-shrink: 0;
  text-decoration: none;
`;

export const LogoImg = styled('img')`
  height: 80px;
  width: 144px;
`;

export const SearchW = styled('div')`
  flex: none;
  width: 500px;
  height: 56px;
  margin-left: 80px;
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.palette.white.light};
  border: 1px solid ${({ theme }) => theme.palette.primary.p010};
  border-radius: 8px;
  padding: 8px 16px;
  gap: 10px;

  svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    opacity: 0.45;
  }

  @media (max-width: 1023px) {
    flex: 1;
    width: 150px;
    margin-left: 0;
  }
`;

export const SearchInput = styled(InputBase)`
  flex: 1;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.primary.p050};

  & input::placeholder {
    color: ${({ theme }) => theme.palette.primary.p040};
    opacity: 1;
  }
`;

export const RightIconsW = styled('div')`
  display: flex;
  align-items: center;
  height: 44px;
  gap: 8px;
  margin-left: auto;
`;

export const RightIconsInnerW = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 150px;
`;

export const StyledBtn = styled(Button)`
  height: 44px;
  width: 44px;
  min-width: unset;
  border-radius: 50%;
  color: ${({ theme }) => theme.palette.info.main};
`;

export const SearchDropdown = styled('div')`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  background: ${({ theme }) => theme.palette.white.main};
  border: 1px solid ${({ theme }) => theme.palette.primary.p010};
  border-radius: 8px;
  box-shadow: ${({ theme }) => `0 4px 16px ${theme.palette.primary.p010}`};
  max-height: 320px;
  overflow-y: auto;
  z-index: 1100;
`;

export const SearchDropdownItem = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  text-decoration: none;
  color: ${({ theme }) => theme.palette.primary.p080};
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.palette.info.light};
  }
`;

export const SearchDropdownEmpty = styled('div')`
  padding: 14px 16px;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.primary.p040};
`;

export const ClearSearchBtn = styled('button')`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.primary.p030};
  flex-shrink: 0;

  &:hover {
    color: ${({ theme }) => theme.palette.primary.p050};
  }

  svg {
    width: 16px;
    height: 16px;
    opacity: 1;
  }
`;

export const MobileTopBar = styled('div')<{ hidden?: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  border-bottom: 3px solid #8282fa;
  gap: 16px;
  padding: 68px 16px 16px;
  height: 207px;
  background: ${({ theme }) => theme.palette.white.main};
  z-index: 1000;
  transition: transform 0.3s ease;
  transform: ${({ hidden }) => (hidden ? 'translateY(-100%)' : 'translateY(0)')};
`;

export const MobileRow = styled('div')`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
`;
